import TitleSection from "../components/TitleSection";
import DataPartners from "../components/DataPartners";
import data from "../../../datasets/usecases/businessdecisioning";
import Recipes from "../components/Recipes";
// import { PricingGetStarted } from "../../Pricing/components/PricingGetStarted";

export const BusinessDecisioning = () => {
  return (
    <div className="business_onboarding">
      <TitleSection data={data} />
      <Recipes data={data} />
      <DataPartners dataPartners={data.dataPartners} />
      {/* <PricingGetStarted /> */}
    </div>
  );
};
